<!--打分记录-->
<template>
	<div class="history-board" ref="board">
		<div class="score-history">
			<div class="account">
				打分记录：
				<i class="iconfont iconcha" @click="closeHistoryBoard"></i>
			</div>
			<el-table :data="tableHistoryRecord" :row-class-name="recordClassName" stripe border>
				<el-table-column prop="studentId" label="ID" align="center" width="75"> </el-table-column>
				<el-table-column prop="score" label="得分" align="center" width="50">
					<template slot-scope="scope">
						<span :class="{ 'show-del': scope.row.deleted === 1 }">{{ scope.row.score }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="updateDate" label="阅卷时间" align="center" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="markName" label="阅卷账户" align="center" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="allMarks" label="得分明细" align="center" show-overflow-tooltip> </el-table-column>
			</el-table>
			<el-pagination
				layout="prev, pager, next"
				@current-change="recordCurrentChange"
				:total="tableHistoryRecordTotal"
				:page-size="3"
				:current-page="recordCurrentPage"
			>
			</el-pagination>
		</div>
		<div class="record-history">
			<div class="account">
				阅卷记录：<span class="record-total">{{ sumHistory }}</span>
			</div>
			<el-table
				:data="tableHistory"
				ref="tableRef"
				style="width: 100%"
				:row-class-name="tableRowClassName"
				@row-click="getTableHistoryRecordClick"
				@current-change="handleCurrentChange"
				highlight-current-row
				stripe
				border
			>
				<el-table-column prop="studentId" label="ID" width="65" align="center" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="score" label="得分" width="50" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<span style="color: red">{{ scope.row.score }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="type" label="状态" width="70" align="center">
					<template slot-scope="scope">
						<span v-text="operateType(scope)"></span>
					</template>
				</el-table-column>
				<el-table-column prop="updateDate" label="阅卷时间" align="center" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="markName" label="阅卷账户" align="center" show-overflow-tooltip> </el-table-column>
			</el-table>
			<el-pagination
				layout="prev, pager, next"
				@current-change="tableCurrentChange"
				:total="tableHistoryTotal"
				:page-size="5"
				:current-page="tableCurrentPage"
			>
			</el-pagination>
		</div>
	</div>
</template>

<script>
import drag from '../../../mixin/drag-mixin'
export default {
	name: 'history-record-board',
	mixins: [drag],
	data() {
		return {
			tableCurrentPage: 1,
			recordCurrentPage: 1,
			query: this.$route.query,
			tableHistory: [],
			tableHistoryTotal: 0,
			tableHistoryRecord: [],
			tableHistoryRecordTotal: 0,
			currentRowVal: {},
			basicInfo: {},
			sumHistory: 0,
			currentHistoryIndex: -1,
			dragStartX: -25,
			dragStartY: 0,
			isRowClicked: false,
			rotateDegree: 0,
			scaleState: 1
		}
	},
	created() {
		this.getScreenWidth()
	},
	mounted() {
		// 获取打分记录
		this.watchCurrentCompEmit()
		this.$nextTick(() => {
			this.dragStartY = document.body.clientHeight - this.$refs['board'].clientHeight - 160
			this.$refs['board'].style.transform = `translateX(${this.dragStartX}px) translateY(${this.dragStartY}px)`
		})
	},
	methods: {
		// 屏幕宽度
		getScreenWidth() {
			if (window.screen.width < 1920) {
				this.dragStartX = -35
			}
		},
		operateType(scope) {
			if (scope.row.type === 0) {
				return '初评'
			} else if (scope.row.type === 2) {
				return '疑难卷'
			} else if (scope.row.type === 3) {
				return '终评'
			}
		},
		// 打分记录 设置状态
		recordClassName({ row }) {
			if (row.deleted === 0) {
				return 'success-row'
			}
			return ''
		},
		//点击 row
		handleCurrentChange(val) {
			this.currentHistoryIndex = val?.index ?? -1
			this.$refs.tableRef.setCurrentRow(val)
		},
		//eventbus
		watchCurrentCompEmit() {
			this.eventBus.$on('flushData', () => {
				this.isRowClicked = false
				// // 获取阅卷记录
				// this.getTableHistory()
				// // 获取打分记录
				// this.getTableHistoryRecord(this.basicInfo, false)
			})
			this.eventBus.$on('basicInformation', cb => {
				this.basicInfo = cb
				if (!this.isRowClicked) {
					// 获取阅卷记录
					this.getTableHistory()
					// 获取打分记录
					this.getTableHistoryRecord(this.basicInfo, false)
				}
			})
		},
		// 关闭历史board
		closeHistoryBoard() {
			this.eventBus.$emit('finalHistoryBoardState', false)
		},
		// 获取阅卷记录
		async getTableHistory() {
			const params = {
				examId: this.query.examId,
				examSubjectId: this.query.examSubjectId,
				paperTextTaskId: this.query.paperTextTaskId,
				page: this.tableCurrentPage,
				type: this.query.type,
				limit: 5
			}
			this.$post('examAnswerMarking/markingHistoryList', params).then(res => {
				this.eventBus.$emit('startTime', new Date().getTime())
				this.sumHistory = res.total
				this.tableHistory = res.data
				this.tableHistoryTotal = res.total
			})
		},
		// 在row中添加索引
		tableRowClassName({ row, rowIndex }) {
			row.index = rowIndex
		},
		// 获取打分记录
		getTableHistoryRecordClick(row) {
			this.getTableHistoryRecord(row, true)
		},
		// 获取打分记录
		getTableHistoryRecord(row, isRowClicked) {
			this.isRowClicked = isRowClicked
			const params = {
				examId: this.query.examId,
				examSubjectId: this.query.examSubjectId,
				paperTextTaskId: this.query.paperTextTaskId,
				studentId: row.studentId,
				type: -4, // 获取打分记录，为-4
				page: this.recordCurrentPage,
				limit: 3
			}
			this.currentRowVal = row
			this.markingHistoryList(params, row).then(res => {
				res.data.forEach(element => {
					if (element.deleted === 0 && element.updateId == this.query.userId && element.type === 3) {
						this.getImageUrlByMark(row, element)
					}
				})
			})
			this.eventBus.$emit('markBoardState', true)
			this.eventBus.$emit('isDisplayMarkScoreBoard', true)
			if (isRowClicked) {
				this.eventBus.$emit('isHistoryState', true)
				this.eventBus.$emit('isShowAutoSubmit', false)
			} else {
				this.eventBus.$emit('isHistoryState', false)
			}
		},
		// 获取阅卷记录
		async markingHistoryList(params) {
			return this.$post('examAnswerMarking/markingHistoryList', params).then(res => {
				this.eventBus.$emit('startTime', new Date().getTime())
				this.tableHistoryRecord = []
				let userFulIndex = 0
				res.data.reverse().forEach((resp, index) => {
					this.tableHistoryRecord.push(resp)
					let resultMark = ''
					JSON.parse(resp.marks).forEach(response => (resultMark = resultMark + response.textTopic + '得' + response.score + '分, '))
					this.tableHistoryRecord[index].allMarks = resultMark
					if (resp.deleted === 0 && resp.updateId === this.query.userId) userFulIndex = index
				})
				this.tableHistoryRecordTotal = res.total
				let imgAddrList = {}
				if (res.data.length > 0) imgAddrList = JSON.parse(res.data[userFulIndex].imgAddr)
				let isHorizontalImage = false
				let imgAddr = {}
				if (Object.keys(imgAddrList).length > 0) {
					isHorizontalImage = imgAddrList.isHorizontalImage
					imgAddr = imgAddrList.imgAddr
				}
				this.eventBus.$emit('deviceName', imgAddrList.deviceName)
				this.eventBus.$emit('horizontalChange', isHorizontalImage)
				if (this.isRowClicked) {
					this.eventBus.$emit('imgAddrListInfo', { imgAddrList: imgAddr })
				} else {
					this.eventBus.$emit('imgAddrListInfo', { imgAddrList: {} })
				}
				this.eventBus.$emit('markBoardState', true)
				if (Object.keys(imgAddrList).length > 0 && Object.keys(imgAddrList.imgAddr).length > 0) {
					const remarks = imgAddrList.imgAddr
					const remarkKey = Object.keys(remarks)[0]
					const firstScoreState = remarks[remarkKey][0][2]
					if (firstScoreState) {
						this.eventBus.$emit('changeFastScoreInfo', { key: firstScoreState.slice(0, 1), val: Number(firstScoreState.slice(1)) })
					}
				}
				return res
			})
		},
		// 获取打分记录，并获取到打分的图片
		getImageUrlByMark(row, basicInfo) {
			const params = {
				examId: this.query.examId,
				examSubjectId: this.query.examSubjectId,
				paperTextTaskId: this.query.paperTextTaskId,
				studentId: row.studentId,
				examAnswerMarkingId: row.pkId,
				markingTaskId: this.query.markingTaskId,
				type: 0,
				minute: 10
			}
			this.$post('examImgInfo/getImageUrlByMark', params).then(res => {
				console.log('res2222', res)
				if (this.isRowClicked) {
					this.eventBus.$emit('examUrlInfo', { urls: res.data.urls })
				}
				let scoreList = []
				res.data.textPaperScores.forEach((responce, index) => {
					let getScore = JSON.parse(basicInfo.marks)[index].score
					if (this.isRowClicked) {
						scoreList.push(Object.assign({}, responce, { getScore }))
					} else {
						scoreList.push(Object.assign({}, responce, { getScore: null }))
					}
				})
				this.eventBus.$emit('horizontalChange', JSON.parse(basicInfo.imgAddr).isHorizontalImage)
				this.eventBus.$emit('emitScoreList', scoreList)
				if (this.isRowClicked) {
					this.eventBus.$emit(
						'basicInformation',
						Object.assign({}, basicInfo, { examAnswerMarkingId: row.pkId, markingImageId: res.data.markingImageId })
					)
				}
			})
		},
		// 阅卷记录 分页
		tableCurrentChange(page) {
			this.tableCurrentPage = page
			this.getTableHistory()
		},
		// 打分记录 分页
		recordCurrentChange(page) {
			this.recordCurrentPage = page
			this.getTableHistoryRecord(this.currentRowVal)
		}
	}
}
</script>

<style lang="less">
.history-board {
	width: 380px;
	background: white;
	position: absolute;
	right: 0;
	top: 0;
	cursor: move;
	padding: 5px 10px 5px;
	box-sizing: border-box;
	border-radius: 8px;
	box-shadow: 0 0 10px rgb(185, 180, 180);
	z-index: 1;
	.account {
		height: 30px;
		line-height: 30px;
		font-size: 18px;
		color: #ff7200;
		@media screen and (max-width: 1920px) {
			height: 25px;
			line-height: 25px;
			font-size: 15px;
		}
		.record-total {
			background: #ff7200;
			color: white;
			font-size: 11px;
			padding: 1px 6px;
			border-radius: 4px;
		}
		.iconfont {
			float: right;
			color: #909399;
			cursor: pointer;
		}
	}
	.score-history {
		margin-top: 5px;
	}
	.show-del {
		text-decoration: line-through;
	}
	/deep/.el-table td,
	.el-table th {
		padding: 5px 0;
	}
}
.el-table__body tr.current-row > td {
	background-color: #d2d2d2 !important;
	color: #fff;
}
.el-table .success-row {
	color: black;
	td {
		background: #eaeaea !important;
	}
}
</style>
